import { useEffect, useState } from "react";
import axios from "axios";

// MUI components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Swal from "sweetalert2";
// Dashboard components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import { hasPermission } from "../../../utils/hasPermissions";
function Staff() {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", role: "" });
  const [editingId, setEditingId] = useState(null);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    fetchRows();
  }, []);

  const getAuthHeaders = () => {
    const token = sessionStorage.getItem("token");
    return {
      Authorization: `Bearer ${token}`,
    };
  };

  const fetchRows = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/bootstrap-staff.php?action=index`, {
        headers: getAuthHeaders(),
      });
      const fetchedRows = response.data;

      setColumns([
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>SNo</span>,
          accessor: "sno",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Staff Name</span>,
          accessor: "staff_name",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Society Id</span>,
          accessor: "society_id",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Is Active</span>,
          accessor: "is_active",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Actions</span>,
          accessor: "actions",
          disableSortBy: true,
        },
      ]);

      const formattedRows = fetchedRows.map((row, index) => ({
        sno: index + 1,
        ...row,
        actions: (
          <>
            {hasPermission("edit") && (
              <Icon
                fontSize="small"
                onClick={() => handleEdit(row)}
                style={{ cursor: "pointer", marginRight: 10 }}
              >
                edit
              </Icon>
            )}
            {hasPermission("delete") && (
              <Icon
                fontSize="small"
                onClick={() => handleDelete(row.staff_id)}
                style={{ cursor: "pointer" }}
              >
                delete
              </Icon>
            )}
          </>
        ),
      }));

      setRows(formattedRows);
    } catch (error) {
      console.error("Error fetching rows:", error);
      showSnackbar("Error fetching data", "error");
    }
  };

  const handleOpen = () => {
    setFormData({ staff_name: "", aadhar_no: "", staff_id: "", society_id: "" });
    setEditingId(null);
    setOpen(true);
  };

  const handleEdit = (row) => {
    setFormData({
      staff_name: row.staff_name,
      aadhar_no: row.aadhar_no,
      society_id: row.society_id,
      staff_id: row.staff_id,
      is_active: row.is_active,
    });
    setEditingId(row.staff_id);
    setOpen(true);
  };

  const handleDelete = async (staff_id) => {
    const result = await Swal.fire({
      title: "Are you sure to delete?",
      icon: "warning",
      width: 500, // 👈 smaller width
      padding: "0.2em", // 👈 smaller padding inside
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      try {
        await axios.post(
          `${API_BASE_URL}/bootstrap-staff.php?action=delete&staff_id=${staff_id}`,
          null,
          {
            headers: getAuthHeaders(),
          }
        );
        showSnackbar("Deleted successfully!", "success");
        fetchRows();
      } catch (error) {
        console.error("Error deleting:", error);
        showSnackbar("Error deleting data", "error");
      }
    }
  };

  const handleSave = async () => {
    try {
      let response;
      if (editingId) {
        response = await axios.post(
          `${API_BASE_URL}/bootstrap-staff.php?action=update`,
          {
            staff_id: editingId,
            ...formData,
          },
          {
            headers: getAuthHeaders(),
          }
        );
      } else {
        response = await axios.post(`${API_BASE_URL}/bootstrap-staff.php?action=create`, formData, {
          headers: getAuthHeaders(),
        });
      }
      if (response.status === 200) {
        showSnackbar("Data saved successfully!", "success");
      } else {
        showSnackbar("Something went wrong. Please try again.", "error");
      }
      setOpen(false);
      fetchRows();
    } catch (error) {
      console.error("Error saving:", error);
      showSnackbar("Error saving data", "error");
    }
  };

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3} display="flex" flexDirection="column" minHeight="100vh">
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" color="white">
                    Staff Information
                  </MDTypography>
                  {hasPermission("create") && (
                    <Button
                      variant="contained"
                      color="white"
                      onClick={handleOpen}
                      startIcon={<Icon>add</Icon>}
                    >
                      Add New
                    </Button>
                  )}
                </MDBox>
              </MDBox>
              <MDBox pt={2}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>

      {/* Add/Edit Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{editingId ? "Edit Staff" : "Add New Staff"}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Aadhar No"
            fullWidth
            value={formData.aadhar_no || ""}
            onChange={(e) => setFormData({ ...formData, aadhar_no: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Staff ID"
            fullWidth
            value={formData.staff_id || ""}
            onChange={(e) => setFormData({ ...formData, staff_id: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Society ID"
            fullWidth
            value={formData.society_id || ""}
            onChange={(e) => setFormData({ ...formData, society_id: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Staff Name"
            fullWidth
            value={formData.staff_name || ""}
            onChange={(e) => setFormData({ ...formData, staff_name: e.target.value })}
          />
          <TextField
            select
            margin="dense"
            label={formData.is_active ? "Is Active" : ""}
            fullWidth
            SelectProps={{
              native: true,
              displayEmpty: true, // <-- Important
            }}
            value={formData.is_active || ""}
            onChange={(e) => setFormData({ ...formData, is_active: e.target.value })}
          >
            <option value="" disabled hidden>
              Select Status
            </option>
            <option value="1">Yes</option>
            <option value="0">No</option>
          </TextField>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => setOpen(false)}
            color="error"
            sx={{ backgroundColor: "red", color: "white" }}
          >
            Cancel
          </MDButton>
          <MDButton
            onClick={handleSave}
            color="info"
            sx={{ backgroundColor: "navyblue", color: "white" }}
          >
            Save
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default Staff;
